import React, { useContext } from "react";
import { PointContext } from "../../../../../contexts/PointContext";

export default function SelfBookTaxi(){

    const pointContext = useContext(PointContext)
    
    
    const {
        point:{
            transportData:{
                selfBookCompanyName='',
                selfBookCompanyPhone='',
                selfBookDriverName='',
                selfBookDriverMobile='',
            }
        }
    } = pointContext;

    return (
        <div>
            {selfBookCompanyName}<br/>
            {selfBookDriverName && <>{selfBookDriverName}<br/></>}
            {selfBookCompanyPhone && <>T: {selfBookCompanyPhone}<br/></>}
            {selfBookDriverMobile && <>M: {selfBookDriverMobile}<br/></>}
        </div>
    );


}
